import { isNil } from 'lodash';

export const initialValues = {
  firstName: '',
  lastName: undefined,
  email: undefined,
  password: ''
};

export const validate = (values) => {
  const errors = {};

  if (values.email !== undefined && values.password === '') {
    // Business requirement: We want to show this error only if
    // there has been anything written in the email input
    errors.password = 'Password is required';
  }

  if (values.email === '') {
    // Business requirement: There should be no error in the initial render of the email field
    errors.email = 'Email is required';
  }

  if (
    values.email !== undefined &&
    values.password !== undefined &&
    (isNil(values.lastName) || values.lastName === '')
  ) {
    errors.lastName = 'Last name is required';
  }

  return errors;
};
